export const copyToClipboard = () => ({
  restrict: "AE",
  scope: {
    copyToClipboardSuccess: "&"
  },
  link: (scope, elem, attrs) => {
    elem.bind("click", () => {
      const textToShare = attrs.clipboardText;
      // create temp element
      const copyElement = document.createElement("span");
      copyElement.appendChild(document.createTextNode(textToShare));
      copyElement.id = "tempCopyToClipboard";
      angular.element(document.body.appendChild(copyElement));

      // select the text
      const range = document.createRange();
      range.selectNode(copyElement);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      // copy & cleanup
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      copyElement.parentNode.removeChild(copyElement);   
      scope.copyToClipboardSuccess();
      scope.$apply();
    });
  },
});



// WEBPACK FOOTER //
// ./src/app/common/components/copy-to-clipboard/copy-to-clipboard.directive.js